import { createSlice } from '@reduxjs/toolkit';
import { filter, orderBy } from 'lodash';
import socket from '../../utils/socket';
import { checkFilterMatch } from '../../utils/filters';

const initialState = {
  isLoading: false,
  error: false,
  contacts: [],
  sortBy: ['username'],
  sortOrders: ['asc'],
  filters: {
    search: ''
  }
};

const slice = createSlice({
  name: 'contacts',
  initialState,
  reducers: {
    // LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    // ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      console.error(state.error);
    },
    getContacts(state, action) {
      const { contacts } = action.payload;
      state.isLoading = false;
      state.contacts = contacts;
    },
    addContacts(state, action) {
      const contacts = action.payload;
      state.contacts = transformStructure(contacts);
    },
    // SORT
    sortByContacts(state, action) {
      const idx = state.sortBy.findIndex((el) => el === action.payload);
      if (idx >= 0) {
        if (state.sortOrders[0] === 'desc') {
          state.sortBy.splice(0, 1);
          state.sortOrders.splice(0, 1);
        } else {
          state.sortOrders[0] = 'desc';
        }
      } else {
        state.sortBy[0] = action.payload;
        state.sortOrders[0] = 'asc';
      }
    },
    // FILTER
    filterSearch(state, action) {
      state.filters.search = action.payload.search;
    }
  }
});

// Reducer
export default slice.reducer;
// Actions
export const { filterSearch, addContacts, sortByContacts } = slice.actions;

// Thunks
export function getContacts({ siteId }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const result = await socket.get('/contacts', { siteId });
      dispatch(slice.actions.getContacts(result));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// Clients version < Comète 1.5.1
// Obj to array of objs
// Utils
export function applyFilter(headCols, contacts, filters, sortBy, sortOrders) {
  if (filters.search) {
    contacts = filter(contacts, (contact) => {
      for (let idx = 0; idx < headCols.length; idx += 1) {
        if (checkFilterMatch(headCols, idx, contact, filters)) {
          return true;
        }
      }
      return false;
    });
  }
  contacts = orderBy(contacts, sortBy, sortOrders);
  return contacts;
}

function transformStructure(obj) {
  return [
    {
      username: obj.contact_client,
      name: 'Responsable client',
      code: 'RESPCLIENT',
      email: obj.contact_client_email,
      phone_mobile_main: obj.contact_client_phone
    },
    {
      username: obj.contact_exp,
      name: 'Responsable exploitation',
      code: 'RESPEXPLOIT',
      email: obj.contact_exp_email,
      phone_mobile_main: obj.contact_exp_phone
    }
  ];
}
